import { render, staticRenderFns } from "./AppFooterAboutUs.vue?vue&type=template&id=ac095568&"
import script from "./AppFooterAboutUs.vue?vue&type=script&lang=js&"
export * from "./AppFooterAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports